import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBRow, MDBCol   } from 'mdbreact';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader, Avatar   } from 'antd';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modaladdexpertbn from './Modaladdexpertbn';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modaladdpresentype from './Modaladdpresentype';





export default class superadmintypemanage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.list = this.list.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selecttpresentationtype')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }

      list() {

        setTimeout(() => {
          api.get('registercon/selecttpresentationtype')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {
        return (
            <MDBContainer fluid>
            <div>
        
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
         
               <MDBAlert color="warning" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}
               
                  
                    
                    <MDBRow >
                    <MDBCol md="8">
                    <PageHeader
                        className="site-page-header"
                      //  onBack={() => null}
                        title="ข้อมูลประเภทนำเสนอ"
                        subTitle="จัดการข้อมูลประเภทนำเสนอ"
                        avatar={{ src: 'https://cdn.iconscout.com/icon/free/png-256/free-expert-advice-542539.png' }}
                    />
                    </MDBCol>
                    <MDBCol md="4">
                    <Modaladdpresentype iduser={localStorage.getItem('iduser')} list={this.list} />
                    </MDBCol>
                    </MDBRow>
   </MDBAlert>
 
                <MDBTable responsive>
                    
                    <MDBTableHead color='light'>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อประเภทนำเสนอ</th>
                        <th>ผู้เพิ่มข้อมูล</th>
                       
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.presentype_name}</td>
                        <td>{article.name_admin}</td>
                       
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>

            </div>
            </MDBContainer>
        )
    }
}
